import * as React from "react";
import CodatError from "../../model/codatErrors/CodatError";
import {Option} from "ts-option";
import DateUtils from "../../utils/DateUtils";
import Loading from "../ui/loading/Loading";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import DataGrid from "../../hiberUiKit/src/organisms/DataGrid/DataGrid";

interface Props {
	items: Option<CodatError[]>
	onMarkAsResolvedClick: (errorId: string) => void
	markAsResolvedLoading: Option<string>
}


export default class CodatErrorsTable extends React.PureComponent<Props> {
	render() {
		return <DataGrid>
			<thead>
			<th style={{width: "8%"}}>Creation date time</th>
			<th style={{width: "9%"}}>Partner Brand</th>
			<th style={{width: "7%"}}>Entity</th>
			<th style={{width: "10%"}}>Reference number</th>
			<th style={{width: "10%"}}>Type</th>
			<th style={{width: "25%"}}>Error message</th>
			<th style={{width: "25%"}}>Errors</th>
			<th style={{width: "10%"}}>Actions</th>
			</thead>
			<tbody>
			{this.props.items.map(items => items.length ? items.map(this.renderItem) : this.renderEmptyList()).getOrElse([
				<tr>
					<td colSpan={8}>
						<Loading isLoading={true}/>
					</td>
				</tr>])}

			</tbody>
		</DataGrid>
	}

	renderItem = (item: CodatError) => {
		const isItemActionLoading = this.props.markAsResolvedLoading.map(id => item.id == id).getOrElse(false)
		return (<tr className={item.solved && "c-item-disabled"}>
			<td>{item.creationDateTime.format(DateUtils.JOB_COMPLETE_DATE_FORMAT)}</td>
			<td>{item.partnerBrand.name}</td>
			<td>{item.errorDataType.replaceUnderscoresWithSpaces()}</td>
			<td>{item.referenceNumber.orNull}</td>
			<td>{item.type.replaceUnderscoresWithSpaces()}</td>
			<td>{item.data.errorMessage}</td>
			<td>{item.data.errors.map(e => <div><strong>{e.itemId} </strong>{e.message}</div>)}</td>
			<td>{!item.solved &&
			<ButtonPrimary label={"Mark as resolved"}
						   onClick={() => this.props.onMarkAsResolvedClick(item.id)}
						   isLoading={isItemActionLoading}
						   disabled={isItemActionLoading}
			/>}</td>
		</tr>)
	}

	renderEmptyList = () => {
		return (
			<tr>
				<td colSpan={8} className={'text-center'}>
					There is no results
				</td>
			</tr>)

	}
}